import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { TypeTypography } from "./CalendarCarouselCard.style";
import {
  useType
} from "../../hooks";
import type { ContentType, Level } from "../../types";

export function TypeLabel({
  learningObjectType,
  learningObjectTypology
}: {
  learningObjectType: ContentType
  learningObjectTypology?: Level
}) {
  const theme = useTheme();
  const typeLabel = useType(learningObjectType, learningObjectTypology);
  const { t } = useTranslation();

  return <TypeTypography aria-label={ `${t("filters_type")} ${learningObjectType}` } variant={ "h5" } sx={ { color: theme.customColors.exploreCardText } }>{ typeLabel }</TypeTypography>;
}

